import { ProviderName, Provider } from "@lib/types/Provider";

export const providers: Partial<Provider>[] = [
  {
    name: ProviderName.Npayex,
    config: {
      apiKey: "",
      baseUrl: "",
    },
    logo: "/assets/images/payment-providers/npayex.svg",
  },
];

const ProviderTransactionFileTypes = [
  "image/*",
  ".pdf",
  ".doc",
  ".docx",
  ".gif",
  ".csv",
  ".xls",
  ".xlsx",
  ".xlsm",
  "application/octet-stream",
];

const ProviderTransactionFileMaxSize = 20; // in MB

export const ProviderTransactionFileConfig = {
  maxSize: ProviderTransactionFileMaxSize,
  types: ProviderTransactionFileTypes,
};
